import jQuery from "jquery";
// Side-effect imports — Bootstrap attaches $.fn.* plugins on load.
// Named imports alone get tree-shaken by esbuild (nothing consumes the exports).
import "bootstrap/js/dist/alert";
import "bootstrap/js/dist/button";
import "bootstrap/js/dist/carousel";
import "bootstrap/js/dist/collapse";
import "bootstrap/js/dist/dropdown";
import "bootstrap/js/dist/modal";
import "bootstrap/js/dist/popover";
import "bootstrap/js/dist/scrollspy";
import "bootstrap/js/dist/tab";
import "bootstrap/js/dist/toast";
import "bootstrap/js/dist/tooltip";
import "bootstrap/js/dist/util";

window.jQuery = jQuery;
window.$ = jQuery;
